var $f5e3df4dc8aa7b54$exports = {};
$f5e3df4dc8aa7b54$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " nepasirinkta.");
  },
  "longPressToSelect": "Nor\u0117dami \u012Fjungti pasirinkimo re\u017Eim\u0105, paspauskite ir palaikykite.",
  "select": "Pasirinkti",
  "selectedAll": "Pasirinkti visi elementai.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nepasirinktas n\u0117 vienas elementas",
      one: function one() {
        return "Pasirinktas ".concat(formatter.number(args.count), " elementas");
      },
      other: function other() {
        return "Pasirinkta element\u0173: ".concat(formatter.number(args.count));
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Pasirinkta: ".concat(args.item, ".");
  }
};
export { $f5e3df4dc8aa7b54$exports as default };